import { Component, Inject, OnInit } from '@angular/core';
import {MatSnackBarRef, MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
@Component({
  selector: 'app-no-store-snackbar',
  templateUrl: './no-store-snackbar.component.html',
  styleUrls: ['./no-store-snackbar.component.scss']
})
export class NoStoreSnackbarComponent implements OnInit {
  constructor(
    public sbRef: MatSnackBarRef<NoStoreSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}
  ngOnInit() {}
}